var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLdpe4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3319_9979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8037 25.1965L36.3268 7.65799C36.3268 7.65799 40.5548 3.56095 44.259 7.2651L54.0618 23.8869",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3797 39.75V37.6187L40.7234 29.2H42.5609V32.15H41.4734L38.1047 37.4812V37.5812H45.6984V39.75H35.3797ZM41.5234 42V39.1L41.5734 38.1562V29.2H44.1109V42H41.5234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6312 78V65.2H21.3375V75.7687H26.825V78H18.6312ZM33.1547 78H28.6172V65.2H33.1922C34.4797 65.2 35.588 65.4562 36.5172 65.9687C37.4464 66.4771 38.1609 67.2083 38.6609 68.1625C39.1651 69.1167 39.4172 70.2583 39.4172 71.5875C39.4172 72.9208 39.1651 74.0667 38.6609 75.025C38.1609 75.9833 37.4422 76.7187 36.5047 77.2312C35.5714 77.7437 34.4547 78 33.1547 78ZM31.3234 75.6812H33.0422C33.8422 75.6812 34.5151 75.5396 35.0609 75.2562C35.6109 74.9687 36.0234 74.525 36.2984 73.925C36.5776 73.3208 36.7172 72.5417 36.7172 71.5875C36.7172 70.6417 36.5776 69.8687 36.2984 69.2687C36.0234 68.6687 35.613 68.2271 35.0672 67.9437C34.5214 67.6604 33.8484 67.5187 33.0484 67.5187H31.3234V75.6812ZM41.4219 78V65.2H46.4719C47.4427 65.2 48.2698 65.3854 48.9531 65.7562C49.6365 66.1229 50.1573 66.6333 50.5156 67.2875C50.8781 67.9375 51.0594 68.6875 51.0594 69.5375C51.0594 70.3875 50.876 71.1375 50.5094 71.7875C50.1427 72.4375 49.6115 72.9437 48.9156 73.3062C48.224 73.6687 47.3865 73.85 46.4031 73.85H43.1844V71.6812H45.9656C46.4865 71.6812 46.9156 71.5917 47.2531 71.4125C47.5948 71.2292 47.849 70.9771 48.0156 70.6562C48.1865 70.3312 48.2719 69.9583 48.2719 69.5375C48.2719 69.1125 48.1865 68.7417 48.0156 68.425C47.849 68.1042 47.5948 67.8562 47.2531 67.6812C46.9115 67.5021 46.4781 67.4125 45.9531 67.4125H44.1281V78H41.4219ZM52.8172 78V65.2H61.4422V67.4312H55.5234V70.4812H60.9984V72.7125H55.5234V75.7687H61.4672V78H52.8172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2564 55.9971L16.8061 55.6531C16.8061 55.6531 11.1439 54.04 12.4997 48.9801L21.9932 32.1797",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2048 30.6758L68.1321 48.5583C68.1321 48.5583 69.5662 54.2684 64.5063 55.6242L45.21 55.8028",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3418 55.8543L49.0777 48.9414V62.5529L37.3418 55.8543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3027 32.2137L26.0387 25.3008V38.9123L14.3027 32.2137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3223 23.9872L58.0582 17.0742V30.6857L46.3223 23.9872Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3319_9979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdpe4);
export default __webpack_public_path__ + "static/media/ldpe4.2bd0a01857f14ab91f51d6a70874326c.svg";
export { ForwardRef as ReactComponent };